import * as React from 'react';
import classnames from 'classnames';

import Input from 'components/inputs/input/Input';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeValue } from 'modules/insights/sov/utils/sov';

import './sov-queries-input-field.scss';

import type { TextEntry } from 'types';
import type { SOVQueryStepType, SOVQueryType } from 'modules/insights/sov/types';

import type { SyntheticEvent } from 'react';

applyTranslations(require('modules/insights/sov/components/queries/modals/sov-queries-modal.i18n.json'));

type Props = {
  queryType: SOVQueryType,
  fieldType: string,
  value: string,
  isChecked: boolean,
  isDisabled: boolean,
  autoFocus: boolean,
  useRefCallback?: boolean,
  onChange: (b: SOVQueryStepType, a: string) => void
};

const MODAL_MSG_KEY = 'sov_queries_modal';

class SOVQueriesInputField extends React.PureComponent<Props> {
  inputRef: TextEntry | undefined | null = null;

  handleRefCallback = (ref: TextEntry): void => {
    this.inputRef = ref;
  };

  handleChange = (event: SyntheticEvent<TextEntry>): void => {
    const { onChange } = this.props;
    const target = event.currentTarget;
    const fieldType = target.dataset.fieldType || '';
    const value = target.value;

    onChange(fieldType, sanitizeValue(value));
  };

  renderInput(): React.ReactNode {
    const { fieldType, value, isDisabled, autoFocus, useRefCallback } = this.props;

    return (
      <Input
        // TODO: Change Input.js `ref` implementation to the newer `createRef` style
        // @ts-ignore - TS doesn't like that `ref` in Input.js can be `null`
        refCallback={useRefCallback ? this.handleRefCallback : null}
        type="text"
        name={fieldType}
        value={value}
        width="responsive"
        placeholder={__t(`${MODAL_MSG_KEY}.placeholders.brand_or_trending_topic`)}
        disabled={isDisabled}
        autoFocus={autoFocus}
        className="sov-queries-input-field__input"
        data={{ 'field-type': fieldType }}
        onChange={this.handleChange}
      />
    );
  }

  render(): React.ReactNode {
    const { queryType, isChecked } = this.props;

    const containerClasses = classnames('sov-queries-input-field', {
      [`sov-queries-input-field--is-disabled-${queryType}`]: !isChecked
    });

    return (
      <div className={containerClasses}>
        {this.renderInput()}
      </div>
    );
  }
}

export default SOVQueriesInputField;
